(function ($) {
	"use strict";

	/*** Slick ***/
	$.each($(".slick"), function () {
		$(this).slick({
			nextArrow: $(this).hasClass('slick-theme-2') ? '<button type="button" class="slick-next"><span class="icon-right"></span></button>' : '<button type="button" class="slick-next"><span class="icon-Arrow-right"></span></button>',
			prevArrow: $(this).hasClass('slick-theme-2') ? '<button type="button" class="slick-prev"><span class="icon-left"></span></button>' : '<button type="button" class="slick-prev"><span class="icon-Arrow-left"></span></button>'
		})
	});

	$('.product--navs .slick-slide').on('click', function (event) {
	   $('.product--slider').slick('slickGoTo', $(this).data('slickIndex'));
	});

	/*** Sticky Header ***/
	$(window).scroll(function(){
	    if ($(window).scrollTop() >= 125) {
	        $('#header').addClass('header--sticky');
	        // $('.header--topbar').hide();
	    }
	    else {
	        $('#header').removeClass('header--sticky');
	        // $('.header--topbar').show();
	    }
	});

	/*** Hover Header ***/ 
	if ($(window).width() > 992){
		if (!$('#header').hasClass('header--hovered')) {
			$(".header--megamenu--item").mouseover(function() {
				$("#header").addClass("header--hovered");
			}).mouseout(function() {
				$("#header").removeClass("header--hovered");
			});
		}
	
		$('#header .dropdown').on('show.bs.dropdown', function(){
			$("#header").addClass("header--hovered");
		});

		$('#header .dropdown').on('hide.bs.dropdown', function(){
			$("#header").removeClass("header--hovered");
		});  
	}

	$('#header-search').on('show.bs.collapse', function(){
		$("#header").addClass("header--hovered");
	});

	$('#header-search').on('hide.bs.collapse', function(){
		$("#header").removeClass("header--hovered");
	});

	/*** Mobile Menu ***/
	var menu = new MmenuLight(
		document.querySelector( '#header-mobile' ),
		"(max-width: 992.98px)"
	);

	var navigator = menu.navigation({
		theme: 'light',
		title: ''
	});

	document.addEventListener(
		"DOMContentLoaded", () => {
			const drawer = menu.offcanvas();

			var $burgerbutton = $(".header--burger");

			$burgerbutton.on("click", function() {
				$burgerbutton.toggleClass("is-active");
				if ($(".mm-ocd").hasClass("mm-ocd--open")) {
					drawer.close();
				} else {
					drawer.open();
				}
			});
		}
	);

	/*****minicart laterale*****/

	document.addEventListener(
        "DOMContentLoaded", () => {
            var minicart = new MmenuLight(
                document.querySelector( "#minicart" )
            );
            
            const drawer = minicart.offcanvas({
				"position": "right",
			});

            document.querySelector( 'a[href="#minicart"]' )
                .addEventListener( 'click', ( evnt ) => {
                    evnt.preventDefault();
                    drawer.open();
                });
			
			var $closeMinicart = $(".closeMinicart");

			$closeMinicart.on("click", function() {  
				drawer.close(); 
			});

			var $openMinicart = $(".openMinicart");

			$openMinicart.on("click", function() {  
				drawer.open(); 
			});
        }
    );
	
	/********/
	var quantitiy=1;
	$('.quantity-right-plus').click(function(e){
		// Stop acting like a button
		e.preventDefault();
		// Get the field name
		var quantity = parseInt($('#quantity').val());
		// If is not undefined
			$('#quantity').val(quantity + 1);
			// Increment
	});

	$('.quantity-left-minus').click(function(e){
		// Stop acting like a button
		e.preventDefault();
		// Get the field name
		var quantity = parseInt($('#quantity').val());
		// If is not undefined
			// Increment
			if(quantity>1){
				$('#quantity').val(quantity - 1);
			}
	}); 
 
	/*******************/
	$(document).on('click', '.btnChanger', function (e) {
		$('#minicart #left').hide();
		$('#firstLayer').hide();
		$('#topFirstLayer').hide();

		if (e.target.dataset.step) {

			$(`#topSecondlayer-s${e.target.dataset.step}`).fadeIn();
			$(`#secondLayer-s${e.target.dataset.step}`).fadeIn();
		}
		$('#minicart #right').removeClass('border-start');
	});

	$('.backfirstLayer').click(function(){
		$('#minicart #left').fadeIn();
		$('#firstLayer').fadeIn();
		$('#topFirstLayer').fadeIn();
		// hide all layers
		$('#topSecondlayer-s1').hide();
		$('#secondLayer-s1').hide();
		$('#topSecondlayer-s2').hide();
		$('#secondLayer-s2').hide();
		$('#topSecondlayer-s3').hide();
		$('#secondLayer-s3').hide();
		//  end
		$('#minicart #right').addClass('border-start');
		$('.slick').slick('refresh');
	});
 
	/*** Breadcrumb ***/
	if ($("body").hasClass("template-product")) {
		$(".subheader").addClass("breadproduit");
	}

	/*** Filters Shadow ***/
	$(document).click(function () {
		$("#filters .dropdown-menu.show").closest("filter--toggle").click();
	});

	if ($(window).width() > 767.98) {
		$("body").on('DOMSubtreeModified', '#prodlisting-container', function () {
			$(document).click(function () {
				$("#filters .dropdown.show, #filters .dropdown-menu.show").removeClass("show");
			});
		});
	}

	$(document).on('click', '#filters .dropdown-menu', function (e) {
		e.stopPropagation();
	});

	if ($(window).width() < 769) {
		$(".filters--togglemobile").on("click", function () {
			$('<div class="filters--open"></div>').appendTo(document.body);
			$("html").addClass("noscroll");
		});

		$(document).on("click", ".filters--close", ".filter--apply", function () {
			$(".filters--open").remove();
			$("html").removeClass("noscroll");
		});

		$(document).on('click', '.filters--open', function () {
			$(".filters--close").click();

			if (!$("#filters").hasClass("show")) {
				$(".filters--open").remove();
				$("html").removeClass("noscroll");
			}
		});

		$(document).on('click', '.filter--apply', function () {
			$(".filters--close").click();

			if (!$("#filters").hasClass("show")) {
				$(".filters--open").remove();
				$("html").removeClass("noscroll");
			}
		});

		$(document).on('show.bs.dropdown', '.filter--dropdown', function () {
			$(this).siblings().hide();
		});

		$(document).on('hide.bs.dropdown', '.filter--dropdown', function () {
			$(this).siblings().show();
		});
	}


	/*** CMS Pages Header ***/
	var CmsHeader = $('.cmspage--header');	

	// For Mobile
	if (window.matchMedia("(max-width: 767px)").matches) {
		HeaderCmsSwitcher('image-mobile', 'video-mobile');
	} else {
		HeaderCmsSwitcher('image', 'video');
	}

	function HeaderCmsSwitcher(imageData, videoData) {
		var imageUrlHeaderCms = CmsHeader.data(imageData);
		var videoUrlHeaderCms = CmsHeader.find('iframe').data(videoData);

		if ( videoUrlHeaderCms != undefined && videoUrlHeaderCms != "" ){
			CmsHeader.addClass('videoheader')
			CmsHeader.find('iframe').attr('src', videoUrlHeaderCms);
		} else {
			if ( imageUrlHeaderCms != "" )
				CmsHeader.css('background-image', 'url('+ imageUrlHeaderCms +')');
		}
	}

	// Device type function
	function deviceType() {
		const ua = navigator.userAgent;
		if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
			return "tablet";
		}
		else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
			return "mobile";
		}
		return "desktop";
	};

	// collection toggle readmore
	if (window.matchMedia("(max-width: 767px)").matches) {
		$('.collection--header--desc').readmore({ speed: 15, collapsedHeight: 30, moreLink: '<a href="#" class="btn-more">Lire plus</a>', lessLink: '<a href="#" class="btn-less">Voir moins</a>' });
	} else {
		$('.collection--header--desc').readmore({ speed: 15, collapsedHeight: 60, moreLink: '<a href="#" class="btn-more">Lire plus</a>', lessLink: '<a href="#" class="btn-less">Voir moins</a>' });
	}

	/***************************/
	/******* scrollToTop *******/
	/***************************/
	function scrollToTop() {
		var $scrollUp = $("#BackToTop"),
		  $lastScrollTop = 0,
		  $window = $(window);
	
		$window.on("scroll", function () {
		  var st = $(this).scrollTop();
		  if (st > $lastScrollTop) {
			$scrollUp.css({ bottom: "-110px" });
		  } else {
			if ($window.scrollTop() > 200) {
			  $scrollUp.css({ bottom: "110px" });
			} else {
			  $scrollUp.css({ bottom: "-110px" });
			}
		  }
		  $lastScrollTop = st;
		});
	
		$scrollUp.on("click", function (evt) {
		  $("html, body").animate({ scrollTop: 0 }, 600);
		  evt.preventDefault();
		});
	  }
	  scrollToTop();
})(jQuery);